import { render } from "./HeroiconsOutlineSun.vue?vue&type=template&id=0103619b"
const script = {}

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSun.vue"]])

export default __exports__